import Vue from "vue";
import Vuex from 'vuex';
import axios from 'axios';
import {router} from '../main.js';

function get_field_by_path( state, path )   {

    let s = path.replace(/\[(\w+)\]/g, '.$1');
    s = s.replace(/^\./, '');
    let a = s.split('.');
    let field = state;
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in field) {
            field = field[k];
        } else  {
            break;
        }
    }

    return field;
}
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        ajax_loading : false,
        data_loaded: false,
        action: 'new',
        current_step: 0,
        steps: [{
            name: 'Personal Details',
            id: 'personal_details'
        },{
            name: 'Basic Information',
            id: 'basic_information'
        },{
            name: 'Hazards',
            id: 'hazards'
        },{
            name: 'Storage',
            id: 'storage'
        },{
            name: 'Moving and Handling',
            id: 'moving_handling'
        },{
            name: 'Using the Product',
            id: 'using_the_product'
        },{
            name: 'First Aid',
            id: 'first_aid'
        },{
            name: 'Fire',
            id: 'fire'
        },{
            name: 'Environmental Hazards',
            id: 'environmental_hazards'
        },{
            name: 'Other',
            id: 'other'
        },{
            name: 'Finish',
            id: 'finish'
        }],
        coshh_personal_details: null,
        coshh_basic_information: null,
        coshh_hazards: null,
        coshh_storage: null,
        coshh_moving_handling: null,
        coshh_using_the_product: null,
        coshh_first_aid: null,
        coshh_fire: null,
        coshh_environmental_hazards: null,
        coshh_other: null,
        coshh_finish: null,


        personal_details_texts: null,
        basic_information_texts: null,
        hazards_texts: null,
        storage_texts: null,
        moving_handling_texts: null,
        using_the_product_texts: null,
        first_aid_texts: null,
        fire_texts: null,
        environmental_hazards_texts: null,
        other_texts: null,
        finish_texts: null,

        submission_state: 'initial',
        submission_rating: null

    },
    mutations: {

        ajax_loading: ( state, payload )=>  {

            state.ajax_loading = payload;

        },

        update_field: ( state, payload ) => {

            console.log(payload.store, payload.name, payload.value);

            const field = get_field_by_path( state, payload.store );
            console.log(field.name, field.value);

            field.value = payload.value;
            console.log(field.name, field.value);

        },

        set_rating: ( state, payload ) =>   {

            state.submission_rating = payload;

        },

        set_step: ( state, payload ) => {

            if( payload < 1 )   {

                state.current_step = 0;
                return;

            }

            if( payload > state.steps.length - 1 )  {

                state.current_step = state.steps.length - 1;
                return;

            }

            state.current_step = payload;

        },

        add_repeater_item: ( state, payload )=> {

            const field = get_field_by_path( state, payload.store );

            field.value.push( payload.data );

        },

        remove_repeater_item: ( state, payload )=> {

            const field = get_field_by_path( state, payload.store );
            const idx = field.value.indexOf( payload.id );
            field.value.splice( idx, 1 );

        },

        update_repeater_item: ( state, payload )=> {

            const field = get_field_by_path( state, payload.store );
            field.value[ payload.index ] = payload.data;

        },

        change_repeater_item_index: ( state, payload )=>    {

            const field = get_field_by_path( state, payload.store );
            const a = field.value[ payload.from ];
            const b = field.value[ payload.to ];
            field.value[ payload.from ] = b;
            field.value[ payload.to ] = a;

        },

        add_checkbox_choice: ( state, payload ) =>  {

            const field = get_field_by_path( state, payload.store );

            field.choices.push({
                id: payload.id,
                name: payload.name,
                value: '',
                label: '',
                type: 'text'
            });

            field.checked_items.push( payload.id );

        },

        remove_checkbox_choice: ( state, payload ) =>  {

            const field = get_field_by_path( state, payload.store )

            field.choices.splice( payload.index, 1 );
            const idx = field.checked_items.indexOf( payload.id );
            field.checked_items.splice( idx, 1 );

        },
//todo pri niektorych riskoch sa ulozi ID pri niektorych value. treba to fixnut nech je to vzdy ID

        // myslim, ze toto som vyriesil na strane servera a momentalne to funguje
        update_checkbox_choice: ( state, payload ) =>  {

            const field = get_field_by_path( state, payload.store );

            if( payload.type === 'textfield' )  {

                field.choices[ payload.index ].value = payload.value;

            } else if( payload.type === 'checkbox' )    {

                // const idx = state[ payload.store ][ payload.field_index ].checked_items.indexOf( payload.id );
                const idx = field.checked_items.indexOf( payload.id );

                if( idx === -1 )    {

                    // state[ payload.store ][ payload.field_index ].checked_items.push( payload.id );
                    // tu bolo v sops-e payload.id ???? preco ?
                    field.checked_items.push( payload.value );

                } else  {

                    // state[ payload.store ][ payload.field_index ].checked_items.splice( idx, 1 );
                    field.checked_items.splice( idx, 1 );

                }

            }

        },

        set_submission_status:( state, payload ) => {

            state.submission_state = payload;

        },

        update_submission: ( state, payload )   =>  {

            state.action = 'edit';
            state.intro_read = true;
            console.log(payload);
            Vue.localStorage.set( 'token', payload );

        },

        set_initial_data: ( state, payload ) => {

            state.data_loaded = true;
            state.coshh_personal_details = payload.data.coshh_personal_details;
            state.coshh_basic_information = payload.data.coshh_basic_information;
            for( let i  = 0; i < payload.data.coshh_hazards.length; i++ )  {

                if( payload.data.coshh_hazards[i].type == 'toggle' && payload.data.coshh_hazards[i].value == '' )
                payload.data.coshh_hazards[i].value = false;
            }
            state.coshh_hazards = payload.data.coshh_hazards;
            state.coshh_storage = payload.data.coshh_storage;
            state.coshh_moving_handling = payload.data.coshh_moving_handling;
            state.coshh_using_the_product = payload.data.coshh_using_the_product;
            state.coshh_first_aid = payload.data.coshh_first_aid;
            state.coshh_fire = payload.data.coshh_fire;
            state.coshh_environmental_hazards = payload.data.coshh_environmental_hazards;
            state.coshh_other = payload.data.coshh_other;
            state.coshh_finish = payload.data.coshh_finish;

            // texts
            state.personal_details_texts = payload.data.texts.personal_details;
            state.basic_information_texts = payload.data.texts.basic_information;
            state.hazards_texts = payload.data.texts.hazards;
            state.storage_texts = payload.data.texts.storage;
            state.moving_handling_texts = payload.data.texts.moving_handling;
            state.using_the_product_texts = payload.data.texts.using_the_product;
            state.first_aid_texts = payload.data.texts.first_aid;
            state.fire_texts = payload.data.texts.fire;
            state.environmental_hazards_texts = payload.data.texts.environmental_hazards;
            state.other_texts = payload.data.texts.other;
            state.finish_texts = payload.data.texts.finish;

            if( payload.data.action === 'edit' )   {

                state.action = 'edit';
                state.intro_read = true;

            }

        }

    },
    actions: {
        upload( { commit }, form_data ) {

            commit( 'ajax_loading', true );

            const token = Vue.localStorage.get( 'token' );
            const base_uri = Vue.config.API_UPLOAD_URL + token;

            return axios.post( base_uri, form_data )
                .then( x => x.data )
                .finally( () => commit( 'ajax_loading', false ) );

        },
        init({ commit }, payload ){

            commit( 'ajax_loading', true );

            const promise = new Promise( ( resolve, reject ) => {

                const base_uri = Vue.config.API_URL + payload.token;

                axios.get( base_uri )
                    .then( ( result ) => {

                        // console.log( result );
                        Vue.localStorage.set( 'token', payload.token );
                        commit( 'set_initial_data', result );

                        resolve();

                    } ).catch( error => {

                        console.log('push_error');
                        router.push( '/error' );
                        reject( error );

                    } ).finally( () => commit( 'ajax_loading', false ) );

            } ).catch( error=> {
                console.log( error );
            } );
            return promise;

        },
        submit( { commit, state } )    {

            commit( 'ajax_loading', true );

            const promise = new Promise( ( resolve, reject ) => {

                const token = Vue.localStorage.get( 'token' );
                const base_uri = Vue.config.API_URL + token;

                if( state.action === 'new' )    {

                    axios.post( base_uri, state  )
                        .then( ( result ) => {
    // console.log(result);
                            // window.location.href = result.data.return_url;
                            resolve( result );

                        } ).catch( error => {

                            reject( error );
                            commit( 'set_submission_status', 'error' );

                        } ).finally( () => commit( 'ajax_loading', false ) );

                } else if( state.action === 'edit' )    {

                    axios.put( base_uri, state  )
                        .then( ( result ) => {
                            // console.log(result);
                            // window.location.href = result.data.return_url;
                            resolve( result );

                        } ).catch( error => {

                            reject( error );
                            commit( 'set_submission_status', 'error' );

                        } ).finally( () => commit( 'ajax_loading', false ) );

                }


            } ).catch( error=> {

                console.log( error );

            } );
            return promise;

        }
    }

});